import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { UnitType } from '../room-availability-v2/unit-type.model';

@Component({
  selector: 'room-gallery',
  templateUrl: './room-gallery.component.html',
  styleUrls: ['./room-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoomGalleryComponent implements OnInit {


@Input() public unitType: UnitType;
@Input() public images: Array<string>;
@Input() public noImages: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-gallery/room-gallery.component.ts